import {
  CHESS_SIDE,
  TOURNAMENT_GAME_RESULT,
  TOURNAMENT_GAME_RESULT_SCORE,
  TOURNAMENT_GAME_RESULT_TEXT,
} from "vue-chess-shared/constants";

const GameHelper = {
  hasPlayerMismatch(game) {
    if (!game.matchRef) return false;
    if (!game.matchRef.player1 && game.whiteUsername) return true;
    if (!game.matchRef.player2 && game.blackUsername) return true;
    if (
      game.matchRef.player1 &&
      game.matchRef.player1.username !== game.whiteUsername
    ) {
      return true;
    }
    return !!(
      game.matchRef.player2 &&
      game.matchRef.player2.username !== game.blackUsername
    );
  },

  isCompleted: function (game) {
    return (
      game.matchRef &&
      game.matchRef.result &&
      game.matchRef.status !== "aborted" &&
      !this.hasPlayerMismatch(game)
    );
  },

  isUnfinished: function (game) {
    return (
      game.whiteResult == TOURNAMENT_GAME_RESULT.UNFINISHED ||
      game.blackResult == TOURNAMENT_GAME_RESULT.UNFINISHED
    );
  },

  tournamentResultScore: function (resultEnum) {
    if (resultEnum == null) return 0;
    return TOURNAMENT_GAME_RESULT_SCORE[resultEnum];
  },

  tournamentResultText: function (resultEnum) {
    if (resultEnum == null) return "";
    return TOURNAMENT_GAME_RESULT_TEXT[resultEnum];
  },

  scoreText: (whiteScore, blackScore) => {
    if (whiteScore == null || blackScore == null) return "";
    return `${whiteScore === 0.5 ? "½" : whiteScore} - ${
      blackScore === 0.5 ? "½" : blackScore
    }`;
  },

  resultText: (whiteScore, blackScore, result) => {
    let s1 = "";
    switch (result) {
      case "abort":
        s1 = "Game aborted.";
        break;
      case "player_abort":
        s1 = "Player aborted.";
        break;
      case "white_abort":
        s1 = "White aborted.";
        break;
      case "black_abort":
        s1 = "Black aborted.";
        break;
      case "forfeit":
        s1 = `${
          whiteScore === 1 ? "Black" : blackScore === 1 ? "White" : "Both"
        } forfeited.`;
        break;
      case "checkmate":
        s1 = "Checkmate.";
        break;
      case "stalemate":
        s1 = "Stalemate.";
        break;
      case "threefold_repetition":
        s1 = "The current board position has occurred three or more times.";
        break;
      case "insufficient_material":
        s1 = "Insufficient material.";
        break;
      case "draw":
        // s1 = "50-move rule.";
        break;
      case "timeout":
        s1 = `${whiteScore === 1 ? "Black" : "White"} time out.`;
        break;
      case "bare king":
        s1 = "Bare king.";
        break;
      case "resign":
        s1 = `${whiteScore === 1 ? "Black" : "White"} resigned.`;
        break;
      case "draw by agreement":
        s1 = "Draw by agreement.";
        break;
      case "disqualified":
        s1 = `${
          whiteScore === 1
            ? "Black has"
            : blackScore === 1
            ? "White has"
            : "Both have"
        } been disqualified due to violation of the Fair Play rules.`;
        break;
      case "invalid":
        s1 = "The match was invalidated";
        break;
      default:
        break;
    }

    let s2 = "";
    if (whiteScore === 1) s2 = "White is victorious";
    else if (blackScore === 1) s2 = "Black is victorious";
    else if (whiteScore === 0.5) s2 = "The game is drawn";

    return `${s1}
    ${s2}`;
  },
};

export default GameHelper;

export const getPlayerColor = function (match, userId) {
  if (!match) return "";

  if (match.player1 && match.player1.user_id === userId) {
    return CHESS_SIDE.WHITE;
  }

  if (match.player2 && match.player2.user_id === userId) {
    return CHESS_SIDE.BLACK;
  }

  return "";
};
